module.exports = __webpack_public_path__ + "img/clients2-1680.ebe5921.png";